import React, { Component } from "react";
import "./ChooseCharacter.scss";

class ChooseCharacter extends Component {
  render() {
    return (
      <div className="choose-label">
        {this.props.text} <span className="blinker"> </span>
      </div>
    );
  }
}

export default ChooseCharacter;
